export default __webpack_public_path__ + "static/media/mockup-map-presentation.89ba8442.png";